import { render, staticRenderFns } from "./YogunBakim.vue?vue&type=template&id=44662b6c&"
import script from "./YogunBakim.vue?vue&type=script&lang=js&"
export * from "./YogunBakim.vue?vue&type=script&lang=js&"
import style0 from "./YogunBakim.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports